import logo from './logo.svg';
import './App.css';
import _ from "lodash";
import { HashRouter as Router, Link } from "react-router-dom";
import { DisplayRoute } from "./routes";
import { useEffect, useMemo, useState, useRef } from 'react';

import { useAtom } from "jotai";
import {isSmallAtom,isLandscapeAtom,isShowingHelpAtom} from './atoms/atom.config.js'
import { mobileWidth, GA_ID } from './constants';
import useDeviceSize from './components/useDeviceSize';
import Header from './components/Header'
// import MobileMenu from './components/MobileMenu'
import { ModalOverlay, ModalOverlaySmall } from "./components/ModalOverlay";

// google analytics init
// https://github.com/react-ga/react-ga
// import ReactGA from 'react-ga';
// ReactGA.initialize(GA_ID);
// console.log("initialised google analytics:", GA_ID);

// google tag manager
// https://github.com/alinemorelli/react-gtm
import TagManager from 'react-gtm-module'
const tagManagerArgs = {
  gtmId: GA_ID,
  dataLayer: { page: 'home' },
  events: { 'gtm.start':new Date().getTime(), event:'gtm.js' }
}
console.log("* TagManager INIT")
TagManager.initialize(tagManagerArgs)

/*
Paste this code as high in the <head> of the page as possible:
<!-- Google Tag Manager -->
<script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-TC6S9RZ');</script>
<!-- End Google Tag Manager -->
*/

function App() {
  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
	const [, setIsLandscape] = useAtom(isLandscapeAtom);
  const [isHelp, setIsHelp] = useAtom(isShowingHelpAtom);

	useEffect(() => {
    handleResize();
		window.addEventListener('resize', _.debounce(() => handleResize(), 10));

    console.log("REACT_APP_MY_ENVIRONMENT_VARIABLE", process.env.REACT_APP_MY_ENVIRONMENT_VARIABLE);
    console.log("PUBLIC_URL", process.env.PUBLIC_URL);

		return () => {
      window.removeEventListener('resize', _.debounce(() => handleResize(), 10));
    }
	}, []);

  const checkLandscape = () => {
    const landscape = window.innerWidth > window.innerHeight;
    setIsLandscape(landscape);
  }

  const onMenuClicked = (e) => {
    console.log("onMenuClicked",e)
  }
  const onHelpClicked = (e) => {
    console.log("onHelpClicked",e)
    setIsHelp(true)
  }
  // const onHelpClosed = (e) => {
  //   console.log("onHelpClosed",e)
  //   setIsHelp(false)
  // }

	const handleResize = () => {
    //isMobile && checkLandscape();
    checkLandscape();
		setIsSmall(window.innerWidth < mobileWidth);
	}

  return (
    
    <div className="App">
      <Router>
        <Header onMenuClicked={onMenuClicked} onHelpClicked={onHelpClicked}/>
        <DisplayRoute />
        
      </Router>
    </div>
    
  );
}

export default App;
